<router-view v-if="!isAppLoading"></router-view>
<loading v-model:active="isAppLoading" :can-cancel="false" :is-full-page="true"  loader="bars"/>
<p-toast></p-toast>
<p-confirm-dialog />
